import React from 'react';
import {
  Box,
  Skeleton,
  Paper,
} from '@mui/material';

const ChatSkeleton: React.FC = () => {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Skeleton variant="text" width="40%" height={32} />
        <Skeleton variant="text" width="25%" height={20} />
      </Box>

      {/* Chat messages */}
      <Box sx={{ flex: 1, p: 2, overflow: 'auto' }}>
        {/* User message */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Paper sx={{ p: 2, maxWidth: '70%', bgcolor: 'primary.light' }}>
            <Skeleton variant="text" width={200} />
            <Skeleton variant="text" width={150} />
          </Paper>
        </Box>

        {/* AI message */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
          <Paper sx={{ p: 2, maxWidth: '70%' }}>
            <Skeleton variant="text" width={300} />
            <Skeleton variant="text" width={280} />
            <Skeleton variant="text" width={250} />
          </Paper>
        </Box>

        {/* User message */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Paper sx={{ p: 2, maxWidth: '70%', bgcolor: 'primary.light' }}>
            <Skeleton variant="text" width={180} />
          </Paper>
        </Box>

        {/* AI message loading */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
          <Paper sx={{ p: 2, maxWidth: '70%' }}>
            <Skeleton variant="text" width={250} />
            <Skeleton variant="text" width={200} />
          </Paper>
        </Box>
      </Box>

      {/* Input area */}
      <Box sx={{ p: 2, borderTop: 1, borderColor: 'divider' }}>
        <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }} />
      </Box>
    </Box>
  );
};

export default ChatSkeleton;





